import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import type { PostAuthor } from '@repo/supergraph/structuredContent/hydration/BankingWhatTheNerdsThink/schema';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';

type Props = StructuredContentDocument<{
  children: StructuredContentDocument;
  author: PostAuthor;
}>;

export function BankingWhatTheNerdsThink({ props }: Props) {
  const { author, children } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        paddingX: { md: '1.5rem', xs: '1rem' },
        paddingY: '1.5rem',
        backgroundColor: 'greens.lightest',
        borderRadius: { xs: 0, md: '1rem' },
      }}
    >
      <Typography variant="textBold" sx={{ fontSize: '20px' }}>
        What the Nerds think
      </Typography>
      <StructuredContentRenderer doc={children} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Image
          src={author.featuredMedia.croppedImage.sourceUrl ?? ''}
          alt={`${author.fullName} Author Avatar`}
          height={45}
          width={45}
          unoptimized
          style={{
            borderRadius: '50%',
            position: 'relative',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            flex: '1 0 0',
          }}
        >
          <Typography variant="textBold">{author.fullName}</Typography>
          <Typography variant="text" sx={{ color: 'neutral.dark', fontSize: '14px' }}>
            {author.jobTitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
